/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterCreator_viewer$ref: FragmentReference;
export type SbSharedRefineMenuFilterCreator_viewer = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_viewer$ref,
  +$refType: SbSharedRefineMenuFilterCreator_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterCreator_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '0e18e5187b12e17e380593bb93529af4';
module.exports = node;
